module.exports = __webpack_public_path__ + "img/btn_playstore.6f110f05.svg";